import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Collapse } from '@mui/material';
import { runOnActivationKey } from '../../../utils/keyboard.utils';
import TargetConversionCell from '../../target/components/TargetConversionCell/TargetConversionCell';
import OrderTargetBreakdownList from './components/OrderTargetBreakdownList/OrderTargetBreakdownList';
import useOrderTargetsStyles from './orderTargets.styles';
import { OrderTargetExpansion, OrderTargetListRow } from './orderTargets.types';
import useOrderTargetListItem from './useOrderTargetListItem';

interface OrderTargetListItemProps {
  target: OrderTargetListRow;
  expansion: OrderTargetExpansion;
  testId?: string;
  onOpenTarget?: () => void;
}

const OrderTargetListItem = ({
  target,
  expansion,
  testId,
  onOpenTarget,
}: OrderTargetListItemProps) => {
  const { classes, cx } = useOrderTargetsStyles();
  const { title, attainmentLabel, breakdownRows, viewOnOrderLabel } =
    useOrderTargetListItem(target);

  return (
    <Box test-id={testId} className={classes.root}>
      <Box
        role="button"
        tabIndex={0}
        aria-expanded={expansion.isExpanded}
        className={cx({
          [classes.header]: true,
          [classes.collapsedHeader]: !expansion.isExpanded,
        })}
        onClick={expansion.toggle}
        onKeyDown={(event) => runOnActivationKey(event, expansion.toggle)}
      >
        <Typography variant="body2" className={classes.trimmedText}>
          {title}
        </Typography>
        <Box className={classes.headerSummary}>
          <Typography variant="body2" className={classes.trimmedText}>
            {attainmentLabel}
          </Typography>
          <Box className={classes.conversion}>
            <TargetConversionCell
              attainment={target.attainment}
              unit={target.unit}
              targetStatus={target.status}
              labelPosition="left"
              labelVariant="body2"
            />
          </Box>
        </Box>
      </Box>
      <Collapse in={expansion.isExpanded} unmountOnExit>
        <Box className={cx({ [classes.bodyWithoutFooter]: !onOpenTarget })}>
          <OrderTargetBreakdownList
            rows={breakdownRows}
            unit={target.unit}
            targetStatus={target.status}
            breakdown={target.breakdown}
          />
        </Box>
        {onOpenTarget && (
          <Box className={classes.footer}>
            <Button variant="text" color="primary" size="small" onClick={onOpenTarget}>
              {viewOnOrderLabel}
            </Button>
          </Box>
        )}
      </Collapse>
    </Box>
  );
};

export default OrderTargetListItem;
